import { z } from 'zod'

const rowSchema = z.object({
  name: z.string(),
  print_code: z.string(),
  locations: z.string(),
  vendor: z.string(),
  production_time_days: z.string(),
})

export const formSchema = z.object({
  rows: z.array(rowSchema).min(1),
})

export const DEFAULT_ROW: z.infer<typeof rowSchema> = {
  name: '',
  print_code: '',
  locations: '',
  vendor: '',
  production_time_days: '',
}

export const INPUT_CLASS =
  'h-9 border-0 bg-transparent focus-visible:ring-1 min-w-0'
